/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * BFF API
 * OpenAPI spec version: 1.0
 */

/**
 * What the entry is about.
 */
export type VehicleAuditEventDtoSubject = typeof VehicleAuditEventDtoSubject[keyof typeof VehicleAuditEventDtoSubject];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VehicleAuditEventDtoSubject = {
  ACCESS_GRANT: 'ACCESS_GRANT',
  SUSPENSION: 'SUSPENSION',
} as const;
